import Pretender from 'fetch-pretender'
import faker from 'faker'

import users from './fixtures/user'
import serviceTypes from './fixtures/service-type'
import apiKeys from './fixtures/keys'

const REQUEST_DELAY = 1000;

const CODE = {
  OK: 200,
  CREATED: 201,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404
}

let server = null

function registerRoutes(server) {

  server.post('/api/auth/token', function(request) {
    const { login, password } = JSON.parse(request.requestBody) || {}
    const user = users.find(user => user.email === login) || {}
    if (user && user.password === password) {
      return response({
        token: user.authToken || faker.random.uuid()
      })
    } else {
      return response({}, CODE.UNAUTHORIZED)
    }
  }, REQUEST_DELAY)

  server.post('/api/auth/recover', function(request) {
    const { email } = JSON.parse(request.requestBody) || {}
    const user = users.find(user => user.email === email)
    if (user)
      return response({})
    else
      return response({}, CODE.NOT_FOUND)
  }, REQUEST_DELAY)

  server.get('/api/accounts/me', function(request) {
    const { Authorization } = request.requestHeaders || {}
    if (!Authorization)
      return response({}, CODE.UNAUTHORIZED)
    const token = Authorization.replace('Token ', '')
    const user = users.find(user => user.authToken === token)
    if (!user)
      return response({}, CODE.UNAUTHORIZED)
    const { id, email, firstName, lastName } = user
    return response({ id, email, firstName, lastName })
  }, REQUEST_DELAY)

  server.post('/api/accounts', function(request) {
    const { email, password, firstName, lastName } = JSON.parse(request.requestBody) || {}
    const id = faker.random.uuid()
    const authToken = faker.random.uuid()
    const user = { id, email, password, firstName, lastName, authToken }
    users.push(user)
    return response({ id, email, password, firstName, lastName, token: authToken }, CODE.CREATED)
  }, REQUEST_DELAY)

  server.patch('/api/accounts/:id', function(request) {
    const user = users.find(user => user.id === Number(request.params.id))
    if (!user)
      return response({}, CODE.NOT_FOUND)
    const { firstName, lastName } = JSON.parse(request.requestBody) || {}
    Object.assign(user, { firstName, lastName })
    const { id, email } = user
    return response({ id, email, firstName, lastName })
  }, REQUEST_DELAY)

  server.patch('/api/accounts/:id/change_password', function(request) {
    const user = users.find(user => user.id === Number(request.params.id))
    if (!user)
      return response({}, CODE.NOT_FOUND)
    const { oldPassword, newPassword, newPasswordConfirm } = JSON.parse(request.requestBody) || {}
    if (oldPassword !== user.password)
      return response({}, CODE.BAD_REQUEST)
    if (newPassword !== newPasswordConfirm)
      return response({}, CODE.BAD_REQUEST)
    user.password = newPassword
    return response({})
  }, REQUEST_DELAY)

  server.get('/api/service_types', function(request) {
    return response(serviceTypes)
  }, REQUEST_DELAY)

  server.get('/api/keys', function(request) {
    return response(apiKeys)
  }, REQUEST_DELAY)

  server.post('/api/keys', function(request) {
    const { domains, service_type } = JSON.parse(request.requestBody) || {}
    const id = apiKeys.length + 1
    const key = faker.random.uuid()
    const blocked = false
    const created = new Date().toISOString()
    const keyRecord = { id, domains, service_type, key, blocked, created }
    apiKeys.push(keyRecord)
    return response(keyRecord)
  }, REQUEST_DELAY)

  server.patch('/api/keys/:id', function(request) {
    const apiKey = apiKeys.find(key => key.id === Number(request.params.id))
    if (!apiKey)
      return response({}, CODE.NOT_FOUND)
    let { domains, blocked, key } = JSON.parse(request.requestBody) || {}
    if (!key) key = faker.random.uuid()
    Object.assign(apiKey, { domains, blocked, key })
    return response(apiKey)
  }, REQUEST_DELAY)

}

export function createServer() {
  if (!server) {
    server = new Pretender()
    registerRoutes(server)

    server.handledRequest = function(verb, path, request) {
      console.log(`${verb} ${path}`, request)
    }
  }
}

export function getServer() {
  createServer()
  return server
}

export function shutdownServer() {
  server.shutdown()
  server = null
}

function response(payload, statusCode = CODE.OK) {
  return [ statusCode, { "Content-Type": "application/json" }, JSON.stringify(payload) ]
}



// WEBPACK FOOTER //
// ./src/server/config.js